import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Auth0Provider} from "@auth0/auth0-react";

// The "ResizeObserver loop" notice is stopped in public/index.html: it has to
// be caught before the dev server's error screen, which loads with the bundle.

const root = createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain="dev-r0ydksl248ax32zq.us.auth0.com"
    clientId="RPrscCBpm9DYspYzK9dvyb5SNS5H4SFL"
    redirectUri={window.location.origin}
    audience="https://api.contactanchor.com"
    // localstorage, not the in-memory default: with memory, every page reload has
    // to re-authenticate through Auth0's hidden iframe, which Safari and Brave
    // block as a third-party cookie — users would be logged out on each refresh.
    cacheLocation="localstorage"
    useRefreshTokens={true}
  ><App/></Auth0Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
